


















import { computed, defineComponent } from "@vue/composition-api";
import { isAfter } from "@/lib/helpers/time";
import emitter from "@/lib/helpers/emitter";
import { Subscription } from "@teacherskaya/api-provider/dist/api/SubscriptionProvider";
import FormatMoney from "@/components/FormatMoney/FormatMoney";

export default defineComponent({
  name: "ProfileRecurringItem",
  components: { FormatMoney },
  props: {
    subscription: { type: Object as () => Subscription, required: true },
    isSubscribers: { type: Boolean, default: false },
  },
  setup(props) {
    const cancelled = computed(() => props.subscription.recurringBillingSchedule?.cancelled ?? true);

    const userId = computed(() =>
      props.isSubscribers ? props.subscription.consumerId : props.subscription.providerId
    );

    const shownScreenName = computed(
      () => {
        const user = props.subscription[props.isSubscribers ? "consumer" : "provider"] ;
        return user ? user.screenName : "System subscription";
      }
    );

    const amount = computed(() => props.subscription.amount);
    const expired = computed(() => isAfter(new Date(), new Date(props.subscription.expirationTime)));

    const onCancelRebillClick = () => {
      const name = props.isSubscribers ? "blockSubscribers" : "blockSubscriptions";
      emitter.emit("showConfirmRecurringAction", {
        name,
        subscription: props.subscription,
        eventName: "cancelRebill",
      });
    };

    const onRemoveAccessClick = () => {
      const name = props.isSubscribers ? "blockSubscribers" : "blockSubscriptions";
      emitter.emit("showConfirmRecurringAction", {
        name,
        subscription: props.subscription,
        eventName: "removeAccess",
      });
    };

    return { cancelled, userId, shownScreenName, amount, expired, onCancelRebillClick, onRemoveAccessClick };
  },
});
